import { type ChangeEvent, memo, useCallback } from 'react';

import { cn } from '@air/utils-tailwind';

import {
  DESCRIBE_TEXT_MAX_LENGTH,
  workspaceAgentFormInput,
} from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentFormInput';

export type WorkspaceAgentDescribeControlProps = {
  onChange: (value: string) => void;
  placeholder: string | undefined;
  value: string;
};

export const WorkspaceAgentDescribeControl = memo(
  ({ onChange, placeholder, value }: WorkspaceAgentDescribeControlProps) => {
    const handleChange = useCallback(
      (event: ChangeEvent<HTMLTextAreaElement>) => {
        onChange(event.target.value);
      },
      [onChange],
    );

    return (
      <textarea
        aria-label="Your answer"
        className={cn(workspaceAgentFormInput(), 'min-h-16 resize-none')}
        maxLength={DESCRIBE_TEXT_MAX_LENGTH}
        onChange={handleChange}
        placeholder={placeholder ?? 'Type your answer'}
        value={value}
      />
    );
  },
);

WorkspaceAgentDescribeControl.displayName = 'WorkspaceAgentDescribeControl';
